import { Button, DatePicker, Form, Input, InputNumber, Modal } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { updateContractDetail } from "../../../redux/rtk/features/contactDetail/contractDetailSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const SalaryEditSinglePopup = ({ data, setLoading }) => {

	console.log("editSalaryData", data);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [startDate, setsalaryStartDate] = useState(
		dayjs(data?.startDate).format("YYYY-MM-DD")
	);
	const [endDate, setsalaryEndDate] = useState(
		dayjs(data?.endDate).format("YYYY-MM-DD")
	);
	const [calculatedRate, setCalculatedRate] = useState(0);

	const [calculatedMonthlySalary, setCalculatedMonthlySalary] = useState(0);
	const [calculatedDailyHours, setCalculatedDailyHours] = useState(0);
	// const [endDate, setsalaryEndDate] = useState(null);

	const [loader, setLoader] = useState(false);
	const [salaryComment, setsalaryComment] = useState("");

	const { id: user_id } = useParams();
	const dispatch = useDispatch();



	const [initialValues, setInitialValues] = useState({
		salary: data?.salary,
		startDate: dayjs(data?.startDate),
		endDate: dayjs(data?.endDate),
		// endDate: data?.endDate ? dayjs(data?.endDate, "YYYY-MM-DD") : null,
		comment: data?.salaryHistory?.[0]?.comment || "",
		monthlySalary: data?.calculatedMonthlySalary,
		workingHoursPerWeek: data?.calculatedDailyHours,
		workingRatePerHour: data?.calculatedRate,
		annualSalary: data?.annualSalary,
		workingHourPerDay: data?.workingHourPerDay,
		monthlySalary: data?.monthlySalary
	});

	const handleFormValuesChange = (_, allValues) => {
		const annualSalary = allValues.annualSalary || 0;
		const workingHourPerDay = allValues.workingHourPerDay || 0;

		const monthlySalary = annualSalary / 12;

		const dailyHours = workingHourPerDay * 5;

		const annualWorkingHours = workingHourPerDay * 5 * 52;

		const ratePerHour = annualSalary / annualWorkingHours;

		setCalculatedMonthlySalary(monthlySalary.toFixed(2));
		setCalculatedDailyHours(dailyHours.toFixed(2));
		setCalculatedRate(ratePerHour.toFixed(2));
	};

	const onFinish = async (values) => {
		setLoading(true);
		const id = data.id || "";
		console.log("id", id);

		setLoader(true);

		const infodata = {
			...values,
			startDate: startDate ? startDate : null,
			endDate: endDate ? endDate : null,
			monthlySalary: calculatedMonthlySalary,
			workingHoursPerWeek: calculatedDailyHours,
			workingRatePerHour: calculatedRate,
		};
		const resp = await dispatch(updateContractDetail({ id, values: infodata }));
		console.log("resp", resp);

		const userId = data.userId
		console.log("user", userId);


		if (resp.message === "success") {
			setLoader(false);
			console.log("calling dispatch..");

			dispatch(loadSingleStaff(userId));

			// await dispatch(loadSingleStaff(user_id.id));
			// setInitialValues({});

			setsalaryComment("");
			setsalaryStartDate();
			setsalaryEndDate();

			setIsModalOpen(false);
			setLoading(false);
			// window.location.reload();
		} else {
			dispatch(loadSingleStaff(userId));

			setLoading(false);
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding designation");
		setLoader(false);
		setLoading(false);
	};
	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setsalaryComment("");
		setsalaryStartDate();
		setsalaryEndDate();
		setIsModalOpen(false);
		setLoader(false);
		setLoading(false);
	};
	const handleCancel = () => {
		setsalaryComment("");
		setsalaryStartDate();
		setsalaryEndDate();
		setIsModalOpen(false);
		setLoader(false);
		setLoading(false);
	};

	return (
		<>
			<button onClick={showModal} className='mr-2'>
				<BtnEditSvg size={20} />
			</button>
			<Modal
				title={`Edit Salary`}
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}>
				<Form
					style={{ marginBottom: "100px" }}
					eventKey='design-form'
					initialValues={initialValues}
					name='basic'
					labelCol={{
						span: 10,
					}}
					wrapperCol={{
						span: 16,
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'
					onValuesChange={handleFormValuesChange}>
					<div>
						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Start Date'
							name='startDate'
							rules={[
								{
									required: true,
									message: "Please input contact start date!",
								},
							]}
						>
							<DatePicker
								value={startDate ? dayjs(startDate) : null}
								onChange={(date, dateString) => setsalaryStartDate(dateString)}
							/>
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "20px" }}
							label='End Date'
							name='endDate'
						>
							<DatePicker
								value={endDate ? dayjs(endDate) : null}
								onChange={(date, dateString) => setsalaryEndDate(dateString)}
							/>
						</Form.Item>

						<Form.Item
							name="annualSalary"
							label="Annual Salary"
							rules={[{ required: true, message: 'Please enter rate per Hour!' }]}
						>
							<InputNumber placeholder="Enter rate per Hour" />
						</Form.Item>

						<Form.Item
							name="workingHourPerDay"
							label="Working Hours Per Day"
							rules={[{ required: true, message: 'Please enter Working Hours Per Day!' }]}
						>
							<InputNumber placeholder="Enter Working Hours Per Day" />
						</Form.Item>
						<Form.Item
							name="comment"
							label="Comment"
						>
							<Input placeholder="Enter comment" />
						</Form.Item>
						<div className="mb-4 p-4 bg-gray-50 rounded-lg">
							<div className="text-lg font-medium">Calculated Values:</div>
							<div className="text-blue-600">
								<p>Monthly Salary: £{calculatedMonthlySalary}</p>
								<p>Working Hours Per Week: {calculatedDailyHours}</p>
								<p>Rate Per Hour: £{calculatedRate}</p>
							</div>
						</div>

						<Form.Item
							style={{ marginBottom: "20px" }}
							wrapperCol={{
								offset: 6,
								span: 12,
							}}>
							<Button
								onClick={() => setLoader(true)}
								type='primary'
								size='small'
								htmlType='submit'
								block
								loading={loader}>
								Update Now
							</Button>
						</Form.Item>
					</div>
				</Form>
			</Modal>
		</>
	);
};
export default SalaryEditSinglePopup;
